export default "__VITE_ASSET___HBJF4eG__"